import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getCriticalCareSelector } from '../selectors'
import { CriticalCareConstants } from '../store/criticalCare.constants'
import { ICriticalCareState } from '../store/criticalCare.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import {
  setAddToTimeLine,
  setTask,
  setTriggerUtilizedPre,
  setTriggerUtilizedPost,
  setIabpFrequencyPre,
  setIabpFrequencyPost,
  setSlowGasLeakAlarmPre,
  setSlowGasLeakAlarmPost,
  setTimingPre,
  setTimingPost,
  setIabpFillPre,
  setIabpFillPost,
  setAugmentationAlarmSetPre,
  setAugmentationAlarmSetPost,
  setLeftBrachialPulsePre,
  setLeftBrachialPulsePost,
  setDistalPulsePresentInAffectedExtremityPre,
  setDistalPulsePresentInAffectedExtremityPost,
  setInsertionSitePre,
  setInsertionSitePost,
  setExtremityRestrainedPre,
  setExtremityRestrainedPost,
} from '../store/criticalCare.actions'
import { addCriticalCareItem } from '../../../timeline/store/timeline.actions'
import { ICcHpiOptionsState, ICriticalCareOptionsState } from '../../../options/store/options.types'
import { getCcHpiOptionsSelector, getCriticalCareOptionsSelector } from '../../../options/selectors'
import { ICriticalCareOption } from '../../../../common/common.types'

export function* setDefaultFieldValuesForIABP() {
  const criticalCareState: ICriticalCareState = yield select(getCriticalCareSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)

  const criticalCareOptionsState: ICriticalCareOptionsState = yield select(getCriticalCareOptionsSelector)
  const {
    taskOptions,
    slowGasLeakOptions,
    autoManualOptions,

    iabpFrequencyOptions,
    insertionSiteOptions,
    triggerUtilizedOptions,
  } = criticalCareOptionsState

  const ccHpiOptions: ICcHpiOptionsState = yield select(getCcHpiOptionsSelector)
  const { therapeuticHypothermiaOptions } = ccHpiOptions

  const criticalCare: ICriticalCareState = yield select(getCriticalCareSelector)
  const {
    task,
    slowGasLeakAlarmPre,
    slowGasLeakAlarmPost,
    timingPre,
    timingPost,
    IABPFillPre,
    IABPFillPost,
    augmentationAlarmSetPre,
    augmentationAlarmSetPost,
    leftBrachialPulsePre,
    leftBrachialPulsePost,
    distalPulsePre,
    distalPulsePost,
    extremityRestrainedPre,
    extremityRestrainedPost,
    IABPFrequencyPre,
    IABPFrequencyPost,
    insertionSitePulsePre,
    insertionSitePulsePost,
    triggerUtilizedPre,
    triggerUtilizedPost,
  } = criticalCare

  if (taskOptions?.length > 0) {
    if (!task) {
      yield put(setTask(taskOptions[0]))
    }
  }

  if (slowGasLeakOptions?.length > 0) {
    if (!slowGasLeakAlarmPre) {
      yield put(setSlowGasLeakAlarmPre(slowGasLeakOptions[0]))
    }
    if (!slowGasLeakAlarmPost) {
      yield put(setSlowGasLeakAlarmPost(slowGasLeakOptions[0]))
    }
  }

  if (autoManualOptions?.length > 0) {
    if (!timingPre) {
      yield put(setTimingPre(autoManualOptions[0]))
    }
    if (!timingPost) {
      yield put(setTimingPost(autoManualOptions[0]))
    }
    if (!IABPFillPre) {
      yield put(setIabpFillPre(autoManualOptions[0]))
    }
    if (!IABPFillPost) {
      yield put(setIabpFillPost(autoManualOptions[0]))
    }
  }
  if (therapeuticHypothermiaOptions?.length > 0) {
    if (!augmentationAlarmSetPre) {
      yield put(setAugmentationAlarmSetPre(therapeuticHypothermiaOptions[0]))
    }
    if (!augmentationAlarmSetPost) {
      yield put(setAugmentationAlarmSetPost(therapeuticHypothermiaOptions[0]))
    }
    if (!leftBrachialPulsePre) {
      yield put(setLeftBrachialPulsePre(therapeuticHypothermiaOptions[0]))
    }
    if (!leftBrachialPulsePost) {
      yield put(setLeftBrachialPulsePost(therapeuticHypothermiaOptions[0]))
    }
    if (!distalPulsePre) {
      yield put(setDistalPulsePresentInAffectedExtremityPre(therapeuticHypothermiaOptions[0]))
    }
    if (!distalPulsePost) {
      yield put(setDistalPulsePresentInAffectedExtremityPost(therapeuticHypothermiaOptions[0]))
    }
    if (!extremityRestrainedPre) {
      yield put(setExtremityRestrainedPre(therapeuticHypothermiaOptions[0]))
    }
    if (!extremityRestrainedPost) {
      yield put(setExtremityRestrainedPost(therapeuticHypothermiaOptions[0]))
    }
  }
  if (iabpFrequencyOptions?.length > 0) {
    const defaultSelection = iabpFrequencyOptions.find((option: ICriticalCareOption) => option?.defaultItem === 1)

    if (defaultSelection) {
      if (!IABPFrequencyPre) {
        yield put(setIabpFrequencyPre(defaultSelection))
      }
      if (!IABPFrequencyPost) {
        yield put(setIabpFrequencyPost(defaultSelection))
      }
    }
  }

  if (insertionSiteOptions?.length > 0) {
    const defaultSelection = insertionSiteOptions.find((option: ICriticalCareOption) => option?.defaultItem === 1)

    if (defaultSelection) {
      if (!insertionSitePulsePre) {
        yield put(setInsertionSitePre(defaultSelection))
      }
      if (!insertionSitePulsePost) {
        yield put(setInsertionSitePost(defaultSelection))
      }
    }
  }

  if (triggerUtilizedOptions?.length > 0) {
    const defaultSelection = triggerUtilizedOptions.find((option: ICriticalCareOption) => option?.defaultItem === 1)

    if (defaultSelection) {
      if (!triggerUtilizedPre) {
        yield put(setTriggerUtilizedPre(defaultSelection))
      }
      if (!triggerUtilizedPost) {
        yield put(setTriggerUtilizedPost(defaultSelection))
      }
    }
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.criticalCareStateList && pcrDoc.patient?.criticalCareStateList?.length) {
    const index = pcrDoc.patient?.criticalCareStateList?.findIndex(
      (criticalCare) => criticalCare.key === criticalCareState.key
    )
    if (index !== -1) {
      pcrDoc.patient.criticalCareStateList[index] = criticalCareState
    } else {
      pcrDoc.patient?.criticalCareStateList.push(criticalCareState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, criticalCareStateList: [criticalCareState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addCriticalCareItem())
  } catch (e) {
    yield put(throwPcrException(`setDefaultFieldValuesForIABP() error: ${e}`))
  }
}

export function* setDefaultFieldValuesForIABPSaga() {
  yield takeLatest(
    [CriticalCareConstants.SET_DEFAULT_VALUES_FOR_IABP],
    performWithMutexHOG,
    setDefaultFieldValuesForIABP
  )
}
